module.exports = __webpack_public_path__ + "img/infographic-2-cn.a4935cf3.jpg";